import moment from 'moment'
import firebase from 'firebase'
import firebaseService from '../../services/FirebaseService'
import modules from './SpeedUp'

const state = {
  account: {
    name: '',
    email: ''
  },
  rank: 1,
  lvl: 1,
  exp: 0,
  point: 0,
  isSignIn: false,
  isEffectSoundMuted: false,
  isBGMSoundMuted: false,
  progress: [
    // {
    //   category: 'lesson',
    //   area: 2,
    //   stage: 1,
    //   status: 1
    // }
  ],
  achievement: [],
  routine_result: {
    comboCount: 0,
    lastDate: '2019-08-10',
    records: [
      // { date: '2019-08-10' },
    ]
  },
  challenge_result: {
    last: {
      date: '2019-08-30 10:10',
      spendTime: 100,
      inputCount: 0,
      score: 0,
      backspaceCount: 0,
      wrongCount: 0,
      wrongLogs: []
    },
    best: {
      date: '2019-08-30 10:10',
      spendTime: 100,
      inputCount: 0,
      score: 0,
      backspaceCount: 0,
      wrongCount: 0,
      wrongLogs: []
    }
  },
  speedup_result: {},
  lastSyncDate: null
}

const getters = {
  currentLessonProgressCount(state) {
    const lessonProgress = state.progress.filter(progress => {
      return progress.category === 'lesson' && progress.id !== undefined
    })
    return lessonProgress.length
  }
}

const mutations = {
  SET_NAME(state, payload) {
    state.account.name = payload
  },
  SET_EMAIL(state, payload) {
    state.account.email = payload
  },
  ADD_EXPERIENCE(state, payload) {
    state.exp += payload
  },
  ADD_PROGRESS(state, payload) {
    state.progress.push(payload)
  },
  UPDATE_PROGRESS(state, payload) {
    const index = state.progress.findIndex(
      progressItem =>
        progressItem.category === payload.category &&
        progressItem.area === payload.area &&
        progressItem.stage === payload.stage
    )
    state.progress[index].status = payload.status
  },
  REPLACE_ALL_PROGRESS(state, payload) {
    state.progress = payload
  },
  SET_SIGNIN_STATUS(state, payload) {
    state.isSignIn = payload
  },
  SET_LAST_CHALLENGE_RESULT(state, payload) {
    state.challenge_result.last = payload
  },
  SET_BEST_CHALLENGE_RESULT(state, payload) {
    state.challenge_result.best = payload
  },
  RESET_USERDATA(state) {
    state.rank = 1
    state.lvl = 1
    state.exp = 0
    state.point = 0
  },
  RESET_PROGRESS(state) {
    state.progress = []
  },
  RESET_CHALLENGE_RESULT(state) {
    state.challenge_result = {
      last: {
        date: '2019-08-30 10:10',
        spendTime: 100,
        inputCount: 0,
        score: 0,
        backspaceCount: 0,
        wrongCount: 0,
        wrongLogs: []
      },
      best: {
        date: '2019-08-30 10:10',
        spendTime: 100,
        inputCount: 0,
        score: 0,
        backspaceCount: 0,
        wrongCount: 0,
        wrongLogs: []
      }
    }
  },
  ADD_ROUTINE_RECORD(state, payload) {
    state.routine_result.records.push(payload.record)
    state.routine_result.comboCount = payload.comboCount
    state.routine_result.lastDate = payload.lastDate
  },
  SET_LAST_SPEEDUP_RAKUGO_RESULT(state, payload) {
    state.challenge_result.last = payload
  },
  SET_BEST_SPEEDUP_RAKUGO_RESULT(state, payload) {
    state.challenge_result.best = payload
  },
  SET_EFFECT_SOUND_MUTE_STATUS(state, payload) {
    state.isEffectSoundMuted = payload
  },
  SET_BGM_SOUND_MUTE_STATUS(state, payload) {
    state.isBGMSoundMuted = payload
  },
  SET_FINISHED_LESSON_PROGRESS(state) {
    const progress = []
    for (let i = 1; i <= 18; i++) {
      for (let ii = 1; ii <= 6; ii++) {
        progress.push({
          category: 'lesson',
          area: i,
          stage: ii,
          status: 1
        })
      }
    }
    state.progress = progress
  },
  SYNC_USER_INFO(
    state,
    { progress, routine_result, challenge_result, achievement }
  ) {
    state.progress = progress
    state.routine_result = routine_result
    state.challenge_result.best = challenge_result.best
    state.achievement = achievement
    state.lastSyncDate = moment().format('YYYY-MM-DD')
  }
}

const actions = {
  setName({ commit }, name) {
    commit('SET_NAME', name)
  },
  setEmail({ commit }, email) {
    commit('SET_EMAIL', email)
  },
  addExperience({ commit }, exp) {
    commit('ADD_EXPERIENCE', exp)
  },
  async addProgress({ state, commit }, { id, category, area, stage, status }) {
    const sameProgress = state.progress.filter(progressItem => {
      return (
        progressItem.category === category &&
        progressItem.id === id
      )
    })
    if (sameProgress.length) {
      commit('UPDATE_PROGRESS', {
        id,
        category,
        area,
        stage,
        status
      })
    } else {
      commit('ADD_PROGRESS', {
        id,
        category,
        area,
        stage,
        status
      })
    }
    const user = await firebaseService.fetchCurrentUser()
    await firebase
      .firestore()
      .collection('user_info')
      .doc(user.uid)
      .update({
        progress: state.progress
      })
      .catch(error => {
        console.log(error)
        alert(
          'レッスン進捗の更新に失敗しました。レッスンのクリア状況が保存されていない可能性があります。'
        )
      })
  },
  async migrateLessonProgress({ state, commit }) {
    const isOldLessonProgress = state.progress.some(progressItem => progressItem.id === undefined)
    console.log({isOldLessonProgress})
    if ( !isOldLessonProgress ) return
    const newProgress = state.progress.filter(progressItem => {
      return (
        progressItem.category !== 'lesson' ||
        progressItem.category === 'lesson' && progressItem.id !== undefined
      )
    })
    commit('REPLACE_ALL_PROGRESS', newProgress)
    const user = await firebaseService.fetchCurrentUser()
    await firebase
      .firestore()
      .collection('user_info')
      .doc(user.uid)
      .update({
        progress: state.progress
      })
      .catch(error => {
        console.log(error)
        alert(
          'レッスン進捗の更新に失敗しました。レッスンのクリア状況が保存されていない可能性があります。'
        )
      })
  },
  async setSignInStatus({ commit }, isSignIn) {
    commit('SET_SIGNIN_STATUS', isSignIn)
  },
  async setChallengeResult(
    { commit, state },
    {
      date,
      spendTime,
      inputCount,
      score,
      backspaceCount,
      wrongCount,
      wrongLogs,
      isEmbedded
    }
  ) {
    const bestScore = state.challenge_result.best.score
    if (score > bestScore) {
      commit('SET_BEST_CHALLENGE_RESULT', {
        date,
        spendTime,
        inputCount,
        score,
        backspaceCount,
        wrongCount,
        wrongLogs
      })
      if (!isEmbedded) {
        const user = await firebaseService.fetchCurrentUser()
        await firebase
          .firestore()
          .collection('user_info')
          .doc(user.uid)
          .set(
            {
              challenge_result: {
                best: {
                  date,
                  spendTime,
                  inputCount,
                  score,
                  backspaceCount,
                  wrongCount,
                  wrongLogs
                }
              }
            },
            { merge: true }
          )
          .catch(error => {
            console.log(error)
            alert(
              'ルーティーンの進捗更新に失敗しました。状況が保存されていない可能性があります。'
            )
          })
      }
    }
    commit('SET_LAST_CHALLENGE_RESULT', {
      date,
      spendTime,
      inputCount,
      score,
      backspaceCount,
      wrongCount,
      wrongLogs
    })
  },
  async addRoutineRecord({ commit, state }) {
    // 継続更新に変化がない場合は無視
    const isTodayCounted =
      parseInt(moment().diff(state.routine_result.lastDate, 'days')) === 0
    if (isTodayCounted) return

    const isCombo =
      parseInt(moment().diff(state.routine_result.lastDate, 'days')) === 1
    const today = moment().format('YYYY-MM-DD')
    commit('ADD_ROUTINE_RECORD', {
      lastDate: today,
      record: { date: today },
      comboCount: isCombo ? state.routine_result.comboCount + 1 : 1
    })
    const user = await firebaseService.fetchCurrentUser()
    await firebase
      .firestore()
      .collection('user_info')
      .doc(user.uid)
      .update({
        routine_result: state.routine_result
      })
      .catch(error => {
        console.log(error)
        alert(
          'ルーティーンの進捗更新に失敗しました。状況が保存されていない可能性があります。'
        )
      })
  },
  resetUserData({ commit }) {
    commit('RESET_USERDATA')
  },
  resetProgress({ commit }) {
    commit('RESET_PROGRESS')
  },
  resetChallengeResult({ commit }) {
    commit('RESET_CHALLENGE_RESULT')
  },
  setSpeedUpRakugoResult(
    { commit, state },
    { date, score, completeCount, time }
  ) {
    const bestScore = state.challenge_result.best.score
    if (score > bestScore) {
      commit('SET_BEST_CHALLENGE_RESULT', {
        date,
        score,
        completeCount,
        time
      })
    }
    commit('SET_LAST_CHALLENGE_RESULT', {
      date,
      score,
      completeCount,
      time
    })
  },
  setEffectSoundMuteStatus({ commit }, isMuted) {
    commit('SET_EFFECT_SOUND_MUTE_STATUS', isMuted)
  },
  setBGMSoundMuteStatus({ commit }, isMuted) {
    commit('SET_BGM_SOUND_MUTE_STATUS', isMuted)
  },
  setFinishedLessonProgress({ commit }) {
    commit('SET_FINISHED_LESSON_PROGRESS')
  },
  async syncUserInfo({ state, commit }) {
    if (state.lastSyncDate === moment().format('YYYY-MM-DD')) return // 同期回数を1日１回に限定する
    const user = await firebaseService.fetchCurrentUser()
    const doc = await firebase
      .firestore()
      .collection('user_info')
      .doc(user.uid)
      .get()
      .catch(error => {
        console.log(error)
        alert('エラー:個人データの同期に失敗しました')
        throw new Error('エラー:個人データの同期に失敗しました')
      })
    const {
      progress,
      achievement,
      routine_result,
      challenge_result
    } = doc.data()
    commit('SYNC_USER_INFO', {
      progress,
      achievement,
      routine_result,
      challenge_result
    })
  },
  async getNextLessonStage({ state }, lessonAreas) {
    const lessonProgress = state.progress.map(progressItem => {
      if (progressItem.category === 'lesson') return progressItem
    })
    if (lessonProgress.length <= 0) {
      return {
        area: 1,
        stage: 1,
        isCompleted: false
      }
    }
    lessonProgress.sort((a, b) => {
      if (a.area < b.area) {
        return 1
      } else if (a.area === b.area && a.stage < b.stage) {
        return 1
      } else {
        return -1
      }
    })
    const lastFinishedStage = lessonProgress[0] // 最後半エリアのステージ
    const isNextStageInSameArea =
      lessonAreas.findIndex(area => {
        return (
          area.areaId === lastFinishedStage.area &&
          area.stages[lastFinishedStage.stage] // next +1 index -1 = 0
        )
      }) !== -1
    const isNextAreaUnavailable = lessonAreas.findIndex(area => {
        return area.areaId == lastFinishedStage.area + 1
    }) === -1
    const isCompleted =
      !isNextStageInSameArea && isNextAreaUnavailable
    return {
      isCompleted,
      area:
        isNextStageInSameArea || isCompleted
          ? lastFinishedStage.area
          : lastFinishedStage.area + 1,
      stage: isNextStageInSameArea
        ? isCompleted
          ? lastFinishedStage.stage
          : lastFinishedStage.stage + 1
        : 1
    }
  }
}

export default {
  namespaced: true,
  state,
  mutations,
  getters,
  actions,
  modules: {
    SpeedUp: modules
  }
}
